export default (el, props) => {
    el.innerHTML = `Hi! ${props.message}`;
};
